import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '../../components/ui'

const NotFoundPage = () => {
  const navigate = useNavigate()

  const handleGoBack = () => {
    navigate(-1)
  }

  const handleGoHome = () => {
    navigate('/')
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-gray-300 dark:text-gray-600">404</h1>
          <h2 className="text-2xl font-semibold text-gray-700 dark:text-gray-200 mb-4">
            Page Not Found
          </h2>
          <p className="text-gray-500 dark:text-gray-400 mb-8">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>

        <div className="space-y-4">
          <Button onClick={handleGoBack} variant="primary" className="w-full">
            Go Back
          </Button>

          <Button onClick={handleGoHome} variant="secondary" className="w-full">
            Go to Dashboard
          </Button>
        </div>
      </div>
    </div>
  )
}

export default NotFoundPage
